export default function UserWelcome({ firstName, t }) {
    return (
        <h6 className="text-md-end m-0 c-darkOrange text-center"><span className="text-black">{t("Welcome")}</span>
            {firstName}
        </h6>
    )
}